import { DispatchOrder } from './../dispatch-order/dispatch-order';
import {Status} from '../status/status';
import {User} from '../user/user';
import {Client} from '../client/client';
export class Ticket
{
    id: number ;
    title: string ;
    details:string;
    machines: number;
    status: Status;
    user: User;
    dateofticket: string;
    client: Client;
    errorcode: string; 
    dateresolved : string;
    resolution : string;
    current_counter : number; 
    dispatchorder : DispatchOrder; 
    assigned_to : User;
}

export class TicketCreate
{
    id: number;
    user: number;
    title: string;
    details:string;
    machines: number;
    status: number;
    dateofticket: Date;
    client: number;
    errorcode: string; 
    dateresolved: Date;
    current_counter : number;
    fixcat : number ;
    dispatchorder : number; 
    assigned_to : number; 
dispatchitem : String;
resolution: string;
    
}